import API from 'services/api';

export const getUsersAll = () => {
  return API.get('/api/users/all').then(res => res?.data);
};
